import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModalConfig } from '@df/ui/modal/modal-config';
import { ModalRef } from '@df/ui/modal/modal-ref';
// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace NModalLayoutMiddle {
    /**
     * Default setup for left side modal
     */
    export const ModalConfig: ModalConfig = {
        hasBackdrop: true,
        closeOnNavigation: true,
        minWidth: undefined,
        maxWidth: undefined,
        modalClass: 'bg-col-w'
    };
}
@Component({
    selector: 'modal-layout-middle',
    templateUrl: 'modal-layout-middle.html',
    styleUrls: ['modal-layout-middle.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class ModalLayoutMiddleComponent {
    /**
     * Dependencies
     */
    constructor(private modalRef: ModalRef<ModalLayoutMiddleComponent>) {}
    /**
     * Close modal
     */
    close() {
        this.modalRef.close();
    }
}
